import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

const Dashboard = lazy(() => import("@/pages/Dashboard"));
const DailyReportPage = lazy(() => import("@/pages/DailyReportPage"));
const ReviewPage = lazy(() => import("@/pages/ReviewPage"));
const NotificationPage = lazy(() => import("@/pages/NotificationPage"));
const Login = lazy(() => import("@/pages/Login"));
const CrossDomainAuthPage = lazy(() => import("@/pages/CrossDomainAuthPage"));

const CURRENT_HOST = (window.location.hostname || "").toLowerCase();
const IS_REPORT_HOST = CURRENT_HOST.startsWith("report.");
const IS_NOTIFICATIONS_HOST = CURRENT_HOST.startsWith("notifications.");

function PageLoadingFallback() {
  return (
    <div
      className="flex items-center justify-center min-h-[50vh] text-cyan-400/70 text-sm tracking-wide"
      aria-busy="true"
      aria-label="Loading page"
    >
      Loading…
    </div>
  );
}

function HomeByHost() {
  if (IS_REPORT_HOST) return <DailyReportPage />;
  if (IS_NOTIFICATIONS_HOST) return <NotificationPage />;
  return <Dashboard />;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Suspense fallback={<PageLoadingFallback />}>
          <Routes>
            <Route
              path="/login"
              element={
                (IS_REPORT_HOST || IS_NOTIFICATIONS_HOST)
                  ? <Navigate to="/auth" replace />
                  : <Login />
              }
            />
            <Route path="/auth" element={<CrossDomainAuthPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <HomeByHost />
                </ProtectedRoute>
              }
            />
            {IS_REPORT_HOST ? (
              <>
                <Route
                  path="/daily-report"
                  element={
                    <ProtectedRoute>
                      <Navigate to="/" replace />
                    </ProtectedRoute>
                  }
                />
              </>
            ) : IS_NOTIFICATIONS_HOST ? (
              <>
                <Route
                  path="/daily-report"
                  element={
                    <ProtectedRoute>
                      <DailyReportPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/notifications"
                  element={
                    <ProtectedRoute>
                      <Navigate to="/" replace />
                    </ProtectedRoute>
                  }
                />
              </>
            ) : (
              <>
                <Route
                  path="/daily-report"
                  element={
                    <ProtectedRoute>
                      <DailyReportPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/review"
                  element={
                    <ProtectedRoute>
                      <ReviewPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/notifications"
                  element={
                    <ProtectedRoute>
                      <NotificationPage />
                    </ProtectedRoute>
                  }
                />
              </>
            )}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
